import {
  Button, Divider, Form, Input, message, Space,
} from 'antd';
import React from 'react';
import { useMutation } from '@apollo/client';
import { AiOutlineLock, AiOutlineMail } from 'react-icons/all';
import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';
import { TOKEN_CREATE } from '../../../graphql/mutations/tokenCreate';
import { inMemoryAuth } from '../in-memory-auth';
import { formItemLayout } from '../utils/form-item-layout';

export const SignInForm = ({
  setMode,
  form,
}) => {
  const location = useLocation();

  const [tokenCreate, { loading }] = useMutation(TOKEN_CREATE, {
    onCompleted: (data) => {
      if (data.tokenCreate.accountErrors.length === 0) {
        inMemoryAuth.token = data.tokenCreate.token;
        inMemoryAuth.refreshToken = data.tokenCreate.refreshToken;
        inMemoryAuth.csrfToken = data.tokenCreate.csrfToken;
        inMemoryAuth.user = {
          id: data.tokenCreate.user.id,
          email: data.tokenCreate.user.email,
          isStaff: data.tokenCreate.user.isStaff,
          userPermissions: data.tokenCreate.user.userPermissions.map(({ code }) => code),
        };
        message.success(`Good to see you, ${data.tokenCreate.user.email}!`);
        return navigate(
          `${location.pathname !== '/user/auth/' ? location.pathname : '/user/account/'}`,
        );
      }
      return data.tokenCreate.accountErrors.forEach(
        ((err) => message.error(`That didn't work... ${err.message}`)),
      );
    },
  });

  return (
    <Form
      form={form}
      size="large"
      name="login"
      initialValues={{
        remember: true,
      }}
      {...formItemLayout}
      onFinish={(values) => tokenCreate({ variables: values })}
    >
      <Form.Item
        name="email"
        label="E-mail"
        hasFeedback
        validateTrigger="onChange"
        rules={[
          {
            type: 'email',
            message: 'Please provide a valid email address.',
          },
          {
            required: true,
            message: 'Please enter a valid email address.',
          },
        ]}
      >
        <Input
          placeholder="example@example.com"
          autoComplete="email"
          prefix={<AiOutlineMail />}
        />
      </Form.Item>
      <Form.Item
        name="password"
        label="Password"
        hasFeedback
        validateTrigger="onChange"
        rules={[
          {
            required: true,
            message: 'Please enter a password',
          },
          {
            min: 9,
            message: 'Password cannot be shorter than 9 characters',
          },
          {
            whitespace: true,
            message: 'Password cannot contain only spaces.',
          },
        ]}
      >
        <Input.Password
          placeholder="Letters, numbers & symbols"
          autoComplete="current-password"
          prefix={<AiOutlineLock />}
        />
      </Form.Item>
      <Divider />
      <Space className="form-actions">
        <Form.Item
          colon={false}
        >
          <Button type="link" onClick={() => setMode('reset')}>
            Password Reset
          </Button>
        </Form.Item>
        <Form.Item>
          <Button
            htmlType="submit"
            type="primary"
            loading={loading}
          >
            Sign In
          </Button>
        </Form.Item>
      </Space>
    </Form>
  );
};
